/* global axios */
import ApiClient from './ApiClient';

class LeadsReportsAPI extends ApiClient {
  constructor() {
    super('leads_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getLeadsReport({ from, to, strategyId, funnelId, groupBy }) {
    return axios.get(`${this.url}`, {
      params: {
        since: from,
        until: to,
        strategy_id: strategyId,
        funnel_id: funnelId,
        group_by: groupBy,
      },
    });
  }

  getStrategies() {
    return axios.get(`${this.url}/strategies`);
  }

  getClicksReport({ from, to, strategyId }) {
    return axios.get(`${this.url}/clicks`, {
      params: {
        since: from,
        until: to,
        strategy_id: strategyId,
      },
    });
  }

  getCampaignLeads({ from, to, inboxId }) {
    return axios.get(`${this.url}/campaign_leads`, {
      params: {
        since: from,
        until: to,
        inbox_id: inboxId,
      },
    });
  }

  syncCampaignLeads({ from, to, inboxId, webhookUrl }) {
    return axios.post(`${this.url}/sync_campaign_leads`, {
      since: from,
      until: to,
      inbox_id: inboxId,
      webhook_url: webhookUrl,
    });
  }

  syncCampaignLeadsStatus() {
    return axios.get(`${this.url}/sync_campaign_leads_status`);
  }

  getWebhookUrl() {
    return axios.get(`${this.url}/webhook_url`);
  }

  saveWebhookUrl(webhookUrl) {
    return axios.post(`${this.url}/save_webhook_url`, {
      webhook_url: webhookUrl,
    });
  }

  getAutoSyncSettings() {
    return axios.get(`${this.url}/auto_sync_settings`);
  }

  saveAutoSyncSettings({ enabled, interval }) {
    return axios.post(`${this.url}/save_auto_sync_settings`, {
      enabled,
      interval,
    });
  }

  getLeadsHeatmap({ from, to, inboxId }) {
    return axios.get(`${this.url}/leads_heatmap`, {
      params: {
        since: from,
        until: to,
        inbox_id: inboxId,
      },
    });
  }

  getTrafficSources({ from, to, funnelId, groupBy }) {
    return axios.get(`${this.url}/traffic_sources`, {
      params: {
        since: from,
        until: to,
        funnel_id: funnelId,
        group_by: groupBy,
      },
    });
  }

  // Lead Managers
  getLeadManagers() {
    return axios.get(`${this.url}/lead_managers`);
  }

  saveLeadManager({ name, phone }) {
    return axios.post(`${this.url}/save_lead_manager`, { name, phone });
  }

  updateLeadManager({ managerId, name, phone, active }) {
    return axios.patch(`${this.url}/update_lead_manager`, {
      manager_id: managerId,
      name,
      phone,
      active,
    });
  }

  deleteLeadManager(managerId) {
    return axios.delete(`${this.url}/delete_lead_manager`, {
      params: { manager_id: managerId },
    });
  }

  getLeadManagerSettings() {
    return axios.get(`${this.url}/lead_manager_settings`);
  }

  saveLeadManagerSettings(settings) {
    return axios.post(`${this.url}/save_lead_manager_settings`, settings);
  }

  sendLeadManagerDigest({ since }) {
    return axios.post(`${this.url}/send_lead_manager_digest`, { since });
  }

  getLeadWebhookInboxes() {
    return axios.get(`${this.url}/lead_webhook_inboxes`);
  }

  saveLeadWebhookInboxes(inboxIds) {
    return axios.post(`${this.url}/save_lead_webhook_inboxes`, {
      inbox_ids: inboxIds,
    });
  }
}

export default new LeadsReportsAPI();
